<template>
  <div class="about">
    <h1>This is an about page eia</h1>

    <button @click="authenticate">Autenticar</button>
    <button @click="refreshToken">Refresh token</button>
    <button @click="authorizedRequest">Authorized request</button>
    <button @click="revokeToken">Revoke token</button>
    <button @click="getRefreshToken">Get Refresh token</button>
    <button @click="logout">Logout</button>
  </div>
</template>
<script>
import axios from "axios";
import Vue from "vue";
export default {
  methods: {
    authenticate() {
      this.$auth
        .login({
          username: "d34456750",
          password: "test"
        })
        .then(
          res => {
            console.log(res);
          },
          err => {
            console.log(err);
          }
        );
    },
    refreshToken() {
      // obtiene el refresh de la cookie
      // const token = (
      //   document.cookie.split(";").find(x => x.includes("fakeRefreshToken")) ||
      //   "="
      // ).split("=")[1];
      // console.log(token);

      // pide el nuevo token
      axios.post("http://localhost:5000/users/refresh-token").then(res => {
        console.log(res);
      });
    },
    revokeToken() {
      Vue.$http
        .post("http://localhost:5000/users/revoke-token", {
          token:
            "1a748eEkTX1qlzIDt9W4dbYoSJCoymGqU5R4JnyPDnekjnj8dMWDe76acQCbyz%2FfPaJMzQFhH91RTEhJwIcTmw%3D%3D"
        })
        .then(res => {
          console.log(res);
        });
    },
    authorizedRequest() {
      Vue.$http.get("http://localhost:5000/users").then(res => {
        console.log(res);
      });
    },
    getRefreshToken() {
      console.log(document.cookie.split(";"));
      // console.log(
      //   (
      //     document.cookie.split(";").find(x => x.includes("RefreshToken")) ||
      //     "="
      //   ).split("=")[1]
      // );
    },
    logout() {}
  }
};
</script>
